import { useEffect, useState } from "react"
import { queryDuck } from "./MainInterface";

type Field = {
  column_name: string,
  column_type: string,
  foreign_key: boolean,
  referred_column: string,
  referred_table: string,
  table: string,
}

type Edge = {
  from: string,
  to: string,
  column_from: string,
  column_to: string
}

type Step = {
  to: string,
  from: string,
  columns: string
}

let recipeId = "aoWXVHWpdrxtSdWSRx7D";

export default function FieldSelector(props: any) {
  const [fields, setFields] = useState<Field[] | null>(null);
  const [tables, setTables] = useState<string[] | null>(null);
  const [selectedBase, setSelectedBase] = useState("");
  const [relatedTable, setRelatedTable] = useState<string[] | null>(null);
  const [selectedRelate, setSelectedRelated] = useState("");
  const [edgeList, setEdgeList] = useState<any[]>([]);
  const [recipe, setRecipe] = useState<any>(null);
  const [recipeSql, setRecipeSql] = useState("");

  useEffect(() => {
    props.onEvent({message: "GetRecipe", params: {recipeId, setRecipe}});
  }, []);

  useEffect(() => {
    if (props.duckLoaded)
      props.onEvent({message: "GetFields", params: {templateId: "cnmi", setFields}});
  }, [props.duckLoaded]);

  useEffect(() => {
    if (fields) getTable(); 
  }, [fields]);

  useEffect(() => {
    let [relatedTable_, edge] = getRelatedTable(selectedBase, [], [], {});
    let edgeList_ = Object.entries(edge)
      .flatMap((fromEntry: any) => Object.entries(fromEntry[1])
          .flatMap((toEntry: any) => (
            toEntry[1].map((item: {column_from: string, column_to: string}) => (
            { from: fromEntry[0], to: toEntry[0], 
              column_from: item.column_from, column_to: item.column_to }
      )))));
      // .sort((a: any, b: any) => 
      //   a.from < b.from ? -1
      //   : a.from === b.from && a.to < b.to ? -1
      //   : a.from === b.from && a.to === b.to 
      //     && a.column_from < b.column_from ? -1 
      //   : a.from === b.from && a.to === b.to 
      //     && a.column_from === b.column_from 
      //     && a.column_to < b.column_to ? -1
      //   : 1
      // );
    setRelatedTable(relatedTable_);
    setEdgeList(edgeList_);
    // console.table(edgeList_);
  }, [selectedBase]);

  useEffect(() => {
    if (recipe?.items?.length && edgeList.length > 0) {
      let sql = getSql1(recipe.base, recipe.items);
      setRecipeSql(sql || "");
    }
  }, [recipe, edgeList]);

  let getTable = async () => {
    let tables_ = (await 
      queryDuck(`from fields select distinct "table"`, props.duckCon)
    ).map((item: any) => item.table);
    setTables(tables_);
    setSelectedBase("core_encounter")
  }

  function getRelatedTable(
    base: string, 
    output: string[], 
    done: string[], 
    edge: {
      [from: string]: {
        [to: string]: { column_from: string, column_to: string}[]
      }
    }
  ): [
      string[],
      {
        [from: string]: {
          [to: string]: { column_from: string, column_to: string }[]
        }
      }
    ]  {
    if (!fields) return [[], {}];
    let relatedTables = Array.from(new Set(
      fields.filter(
        (field: Field) => {
          if (!field.foreign_key || field.referred_table !== base)
            return false
          if (!(field.table in edge))
            edge[field.table] = {}
          if (!(field.referred_table in edge[field.table]))
            edge[field.table][field.referred_table] = [];
          edge[field.table][field.referred_table].push({
            column_from: field.column_name,
            column_to: field.referred_column
          });
          if (output.includes(field.table) || done.includes(field.table)) 
            return false
          return true
        }).map((field: Field) => field.table)
    ))
    output = output.concat(relatedTables);
    for (const todo of relatedTables) {
      [output, edge] = getRelatedTable(todo, output, done, edge);
      done.push(todo);
    }
    return [output.toSorted(), edge];
  }

  let addField = (field: Field) => {
    props.onEvent({message: "AddRecipeItem", params: {recipeId, item: field, setRecipe}});
  }

  let getSql1 = (base: string, items: Field[]) => {
    let targetDict: {[table: string]: string[]} = {};
    for (const item of items) {
      if (!(item.table in targetDict))
        targetDict[item.table] = [];
      targetDict[item.table].push(item.column_name);
    }
    let started = false;
    let sql = `with ${base}_0 as (\n  from ${base} \n  where \n    ${base}.id >= [START] \n    and ${base}.id <= [END]\n),\n`;
    for (const [targetTable, targetColumns] of Object.entries(targetDict)) {
      if (started)
        sql += ",\n";
      else
        started = true;
      let sql_ = "";
      sql_ += `${targetTable}_0 as (`
      let output = getSql(targetTable);
      if (output.length == 0)
        return console.log("Nothing to process");
      sql_ += `\n  from ${output[0].to}_0`;
      let cur = null;
      for (const step of output) {
        if (step.from !== cur) {
          sql_ = sql_ + `\n  left join ${step.from}\n    on `;
          cur = step.from;
        } else {
          sql_ += '\n    or ';
        }
        let columns = step.columns.split(";")
        sql_ = sql_ + columns.map((column: string) => {
          let fields = column.split("|");
          return `${step.to + (step.to === base ? "_0" : "")}.${fields[0]} = ${step.from}.${fields[1]}`
        }).join("\n    or ");
      }
      sql_ += `\n  select\n    ${output[0].to}_0.id ${targetTable}_0_base_ref_id,`
      for (const targetColumn of targetColumns) {
        sql_ += `\n    count(distinct ${targetTable}.${targetColumn}) ${targetTable}__${targetColumn}__count`;
      } 
      sql_ += `\n  group by all`;
      sql += sql_ + "\n)"; 
    }
    started = false;
    let firstTable = null;
    for (const [targetTable, targetColumns] of Object.entries(targetDict)) {
      if (!started) {
        firstTable = targetTable;
        sql += `\nfrom ${targetTable}_0`;
        started = true;
      } else {
        sql += `\nleft join ${targetTable}_0` + 
               `\n  on ${targetTable}_0.${targetTable}_0_base_ref_id =` + 
               ` ${firstTable}_0.${firstTable}_0_base_ref_id`;
      }
    }
    sql += `\norder by ${firstTable}_0`;
    return sql;
  }

  let getSql = (table: string) => {
    let paths = getPaths(table, []);
    let keyList: string[] = [];
    let output = paths.reduce((
      acc: {to: string, from: string, columns: string}[], 
      cur: {to: string, from: string, columns: string}
    ) => {
      if (!keyList.includes(`${cur.from}->${cur.to}`)) {
        keyList.push(`${cur.from}|${cur.to}`);
        acc.push(cur);
      }
      return acc
    }, []);
    // console.table(paths);
    // console.table(output);
    return output;
  }

  let getPaths = (
    from: string, 
    output: Step[]
  ) => {
    let fromEdges = edgeList.filter((edge: Edge) => edge.from === from);
    let toTables = Array.from(new Set(fromEdges.map((edge: Edge) => edge.to)));
    for (const to of toTables) {
      if (from === to) continue
      output.unshift({
        to, from, 
        columns: fromEdges.filter((edge: Edge) => edge.to === to)
                          .map((edge: Edge) => `${edge.column_to}|${edge.column_from}`)
                          .join(";")
      });
    }
    for (const to of toTables) {
      if (from === to) continue
      let keyList = output.map((step: Step) => step.from);
      if (keyList.includes(to)) {
        output = output.filter((step: Step) => step.from === to)
          .concat(output.filter((step: Step) => step.from !== to))
        continue
      }
      output = getPaths(to, output);
    }
    return output;
  }

  const downloadData = (data: any, name: string) => {
    const link = document.createElement("a");
    link.download = name;
    link.href = URL.createObjectURL(new Blob([JSON.stringify(data)], {type: "text"}));
    link.click();
  }

  //downloadData(recipe, "recipe.json"); 
  //downloadData(fields, "fields.json");

  return (
    <div>
      {fields && <div>{fields.length}</div>}
      <div style={{height: "90vh"}}>
        {tables &&
        <select
          onChange={() => {}}
          value={selectedBase}>
          {tables.map((table: string, index: number) => (
            <option key={index}>{table}</option>
          ))}
        </select>}
        <div style={{display: "flex"}}>
          <div style={{height: "87vh", overflowY: "scroll", flex: 1}}>
            {(relatedTable || []).map((table: any, tableIndex: number) =>
            <div 
              style={{cursor: "pointer"}}
              key={tableIndex}
              onClick={(e: any) => setSelectedRelated(table)}>
              {table}
            </div>)}
          </div>
          {<div style={{height: "87vh", overflowY: "scroll", flex: 1, borderLeft: "solid grey 1px"}}>
            {(fields || [])
              .filter((field: Field) => field.table == selectedRelate)
              .map((field: Field, fieldIndex: number) => (
              <div
                style={{
                  cursor: "pointer", display: "flex", 
                  justifyContent: "space-between",
                  backgroundColor: field.foreign_key ? "lightgrey" : "white"
                }}
                key={fieldIndex}
                >
                <div>{`${field.column_name} (${field.column_type})`}</div>
                <div
                  onClick={(e: any) => addField(field)}>
                  +
                </div>
              </div>
            ))}
          </div>}
          <div 
            style={{
              height: "87vh", overflowY: "scroll", 
              flex: 1, cursor: "pointer", borderLeft: "solid grey 1px"
            }}>
            {recipe &&
            <div>
              {(recipe.items || []).map((item: any, itemIndex: number) => (
                <div 
                  key={itemIndex} 
                  style={{display: "flex", justifyContent: "space-between"}}>
                  <div>{item.table}</div>
                  <div>{item.column_name}</div>
                </div>
              ))}
            </div>}
            <textarea value={recipeSql} readOnly={true} style={{width: "100%", height: "100%"}}/>
          </div>
        </div>
      </div>
    </div>
  )
}
